import { render, staticRenderFns } from "./RedemptionOrigin.vue?vue&type=template&id=3ced9dba"
import script from "./RedemptionOrigin.vue?vue&type=script&lang=js"
export * from "./RedemptionOrigin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports